import { COUNTRIES, type CountryData } from '../constants';

// Create maps for quick lookups
export const COUNTRY_CODE_MAP = new Map(
  COUNTRIES.map((country) => [country.code, country])
);

export const CURRENCY_MAP = new Map(
  COUNTRIES.map((country) => [country.code, country.currency])
);

export const CURRENCY_SYMBOL_MAP = new Map(
  COUNTRIES.map((country) => [country.currency, country.currencySymbol])
);

export const PHONE_CODE_MAP = new Map(
  COUNTRIES.map((country) => [country.code, country.phoneCode])
);

export const PHONE_CODES = Array.from(
  new Set(COUNTRIES.map((country) => country.phoneCode))
);

// Default country (India)
export const DEFAULT_COUNTRY: CountryData = COUNTRIES[0];

// Helper functions
export const getCountryByCode = (code: string): CountryData | undefined => {
  return COUNTRY_CODE_MAP.get(code);
};

export const getCurrencySymbol = (currency?: string): string => {
  return (
    CURRENCY_SYMBOL_MAP.get(currency ?? DEFAULT_COUNTRY.currency) ??
    DEFAULT_COUNTRY.currencySymbol
  );
};

export const getCurrency = (countryCode?: string): string => {
  return (
    CURRENCY_MAP.get(countryCode ?? DEFAULT_COUNTRY.code) ??
    DEFAULT_COUNTRY.currency
  );
};

export const getPhoneCode = (countryCode: string): string => {
  return PHONE_CODE_MAP.get(countryCode) || '+1';
};

export const getCountriesByPhoneCode = (phoneCode: string): CountryData[] => {
  return COUNTRIES.filter((country) => country.phoneCode === phoneCode);
};

// Reverse lookup: get country code by country name
export const getCountryCodeByName = (name: string): string | undefined => {
  const country = COUNTRIES.find(
    (c) => c.name.toLowerCase() === name.toLowerCase()
  );
  return country?.code;
};
